// extracted by mini-css-extract-plugin
module.exports = {"root":"title_root__1z9-j","line":"title_line__zZQT9","text":"title_text__1Jye9","inverted":"title_inverted__1q01N","free":"title_free__30CSn"};